import { PermanentFilterStorage } from './permanent-filter-storage';

export class QuickFilterPermanentStorage {
  constructor(options = {}) {
    const {
      featureName,
      entityName,
      preferenceService,
    } = options;

    this.permanentFilterStorage = new PermanentFilterStorage({
      featureName,
      preferenceService,
      storageKey: this.getStorageKey({
        featureName,
        entityName,
      }),
    });
  }

  /**
   * @private
   * @return {String} - resource and entry ids
   */
  getStorageKey({
    featureName,
    entityName,
  }) {
    return `quick-filter-storage-campaignwebui-${featureName}-${entityName}/QuickFilter`;
  }

  /**
   * @returns {Object} Promise that resolve to Filter object that contains query,
   * name and id
  */
  get() {
    return this.permanentFilterStorage.get();
  }

  /**
   * Save quick filter key and query to session
   * @param {string} key - Filter key
   * @param {Object} value - Filter query object
   * @return {undefined}
   */
  save(key, value) {
    return this.permanentFilterStorage.save({
      key,
      value,
    });
  }

  clean() {
    return this.permanentFilterStorage.delete();
  }
}
